import { jsx as _jsx } from "react/jsx-runtime";
import { useWidth } from "common-frontend-components";
import { GallerySwiper } from "../../../custom/carousels/GallerySwiper";
import { Box, Fade } from "@mui/material";
import { WwwProductCard } from "./WwwProductCard";
export const PostProductsCarousel = ({ items }) => {
    const width = useWidth();
    const sectionWidth = width > 520 ? 3 : width > 180 ? Math.floor(width / 180) : 1;
    const slidesPerView = sectionWidth > items.length ? items.length : sectionWidth;
    return (_jsx(GallerySwiper, { slidesPerView: slidesPerView, spaceBetween: 1, children: items.map((i, index) => _jsx(Fade, { in: true, timeout: index * 500, children: _jsx(Box, { children: _jsx(WwwProductCard, { product: i, width: 180, titleProps: { sx: { width: 160 } } }, void 0) }, void 0) }, i.id)) }, void 0));
};
export const PostProductsFullViewCarousel = ({ items }) => {
    const width = useWidth();
    const sectionWidth = width > 320 ? 2 : width > 150 ? Math.floor(width / 150) : 1;
    const slidesPerView = sectionWidth > items.length ? items.length : sectionWidth;
    return (_jsx(GallerySwiper, { slidesPerView: slidesPerView, spaceBetween: 1, children: items.map((i, index) => _jsx(Fade, { in: true, timeout: index * 500, children: _jsx(Box, { children: _jsx(WwwProductCard, { product: i, width: 150, titleProps: { sx: { width: 140 } } }, void 0) }, void 0) }, i.id)) }, void 0));
};
//# sourceMappingURL=PostProductsCarousel.js.map